import moment from 'moment';
import React, { Component } from 'react'
import { Table } from 'semantic-ui-react';

class InvoiceDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { invoiceCode, type, createdAt, items } = this.props.invoice;
        return <div className='invoice-section'>
            <Table celled>
                {window.innerWidth >= 768 ? <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Description</Table.HeaderCell>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell textAlign='right'>Amount</Table.HeaderCell>
                    </Table.Row>
                </Table.Header> : ''}
                <Table.Body>
                    {window.innerWidth >= 768 ? items.map(i => <Table.Row>
                        <Table.Cell>{i.invoiceItemType}</Table.Cell>
                        <Table.Cell>{i.invoiceItemType == 'Refund Failed' ? i.invoiceItemType : i.description}</Table.Cell>
                        <Table.Cell>{moment(i.createdAt).format('LLL')}</Table.Cell>
                        <Table.Cell textAlign='right'>$ {i.amount}</Table.Cell>
                    </Table.Row>) : items.map(i => <Table.Row>
                        <Table.Cell>Type: {i.invoiceItemType}</Table.Cell>
                        <Table.Cell>Description:  {i.invoiceItemType == 'Refund Failed' ? i.invoiceItemType : i.description}</Table.Cell>
                        <Table.Cell>Date: {moment(i.createdAt).format('LLL')}</Table.Cell>
                        <Table.Cell textAlign='right'>Amount: $ {i.amount}</Table.Cell>
                    </Table.Row>)}
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell textAlign='right'>Total</Table.HeaderCell>
                        <Table.HeaderCell textAlign='right'>$ {items.map(i => i.amount).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)}</Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        </div>
    }
}

export default InvoiceDetails